import useAutoFetch from "v4/hooks/useAutoFetch";
import {generateUrl} from "v4/services/api.service";
import {CORE_SECONDARY_EMAILS_FORM} from "v4/data/apiRoutes";
import {useParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import {useEffect, useMemo} from "react";
import useFetch from "v4/hooks/useFetch";
import jsonToFormData from "v4/utils/jsonToFormData";
import useNotification from "v4/hooks/useNotification";
import {useTranslation} from "react-i18next";

export default function useManageSecondaryEmailsPage() {
    const {t} = useTranslation();
    const {userId} = useParams();
    const methods = useForm();
    const {addSuccessNotification} = useNotification();

    const {data, isLoading} = useAutoFetch(generateUrl(CORE_SECONDARY_EMAILS_FORM, {userId}))

    const form = useMemo(() => {
        if (!data) return null;

        return {
            type: "success:get-form-schema",
            data: data.data,
        }
    }, [data]);

    const [{isLoading: isFormSubmitting, data: submitData, errorData}, submitFetch] = useFetch();

    const onSubmit = (data) => {
        submitFetch({
            url: generateUrl(CORE_SECONDARY_EMAILS_FORM, {userId}),
            config: {
                method: "POST",
                body: jsonToFormData(data),
            },
        });
    }

    useEffect(() => {
        if (!submitData) return;

        addSuccessNotification(t('success'));
    }, [submitData, addSuccessNotification, t]);

    return {
        form,
        errorData,
        methods,
        onSubmit,
        isLoading,
        isFormSubmitting,
    }
}
